import { Navigate, Route, Routes } from "react-router-dom";
import { PublicLayout } from "./components/PublicLayout";
import { HomePage } from "./pages/HomePage";
import { NewsPage } from "./pages/NewsPage";
import { NewsDetailPage } from "./pages/NewsDetailPage";
import { TrainingPage } from "./pages/TrainingPage";
import { ClubPage } from "./pages/ClubPage";
import { ContactPage } from "./pages/ContactPage";
import { TeamsPage } from "./pages/TeamsPage";
import { DatenschutzPage, DownloadsPage, ImpressumPage } from "./pages/StaticPages";
import { AdminRouter } from "./pages/admin/AdminRouter";

export default function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<HomePage />} />
        <Route path="aktuelles" element={<NewsPage />} />
        <Route path="aktuelles/:slug" element={<NewsDetailPage />} />
        <Route path="training" element={<TrainingPage />} />
        <Route path="mannschaften" element={<TeamsPage />} />
        <Route path="verein" element={<ClubPage />} />
        <Route path="kontakt" element={<ContactPage />} />
        <Route path="downloads" element={<DownloadsPage />} />
        <Route path="impressum" element={<ImpressumPage />} />
        <Route path="datenschutz" element={<DatenschutzPage />} />
        <Route path="news" element={<Navigate replace to="/aktuelles" />} />
        <Route path="news/:slug" element={<LegacyNewsRedirect />} />
        <Route path="chronik" element={<Navigate replace to="/verein" />} />
        <Route path="vorstand" element={<Navigate replace to="/verein" />} />
        <Route path="docs" element={<Navigate replace to="/downloads" />} />
        <Route path="anfahrt" element={<Navigate replace to="/training" />} />
      </Route>
      <Route path="admin/*" element={<AdminRouter />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
}

function LegacyNewsRedirect() {
  return <Navigate replace to="/aktuelles" />;
}
